import React, {Component, useEffect, useState} from "react";

import {
    Button,
    Card, Checkbox,
    ConfigProvider,
    DatePicker,
    Flex,
    Form,
    Input,
    Layout,
    message,
    Row, Segmented,
    Select,
    Spin, Table,
    Upload
} from "antd";
import Apiurl from "../ConstURL";

import {
    FileExcelOutlined, InboxOutlined,
} from '@ant-design/icons';

import dayjs from 'dayjs';

import {useAuth} from "../funcs/Authcontext";
import axios, {options} from "axios";
import {format} from "date-fns";
import AsinSalesReport from "./AsinSalesReport";


export default function DownloadExcel() {
    const [form] = Form.useForm()
    const {RangePicker} = DatePicker;
    const [fileList, setFileList] = useState([]);
    const [currentfile, setcurrentfile] = useState(null);
    const [loading, setloading] = useState(false);
    const [lasttimeupdate, setlasttimeupdate] = useState("");

    const [allshops, set_allshops] = useState([])
    const [shopshistory, set_shopshistory] = useState([])

    const [time_from, Set_time_from] = useState("")
    const [time_to, Set_time_to] = useState("")

    const [sku_text, Set_sku_text] = useState("")
    const [sku_disabled, Set_sku_disabled] = useState(false)

    const [asin_text, Set_asin_text] = useState("")
    const [strict_rule, Set_strict_rule] = useState(false)

    const [datacloums, Set_datacloums] = useState([])
    const [datatable, Set_datatable] = useState([])

    const [selected_segment, Set_selected_segment] = useState("По строке")
    // «Все ASIN с продажами» — отдельный раздел; форма выше лишь скрывается, чтобы не терять её состояние.
    const [show_asinreport, Set_show_asinreport] = useState(false)


    useEffect(() => {
        axios.get(Apiurl + "/shop?token=" + localStorage.getItem("token")).then((res: any) => {
            set_allshops(res.data.Data)
        }).catch((err: Error) => {
            console.log(err)
        })

        // axios.get(Apiurl+"/all/items?"+ new URLSearchParams({
        //     token: localStorage.getItem("token"),
        //     filter_category: currentValue
        //
        // })).then((res: any) => {
        //     if (res.status === 200) {
        //
        //         setAllCount(res.data.Allcount)
        //         setLoading(false)
        //     }else {
        //         message.error("Ошибка в отправке запроса!")
        //     }
        //
        // }).catch((err: Error) => {
        //     console.log(err)
        // })


    }, []);

    const disabledRangeTime = (_, type) => {
        if (type === 'start') {
            return {

                disabledSeconds: () => [55, 56],
                disabledMinutes: () => [55, 56],
            };
        }
        return {
            disabledSeconds: () => [55, 56],
            disabledMinutes: () => [55, 56],
        };
    };
    const onChangeFilterfilter_date = (text) => {

        console.log(new Date().getTimezoneOffset())
        if (text) {
            console.log(text[0].format('YYYY-MM-DD'))
            console.log(text[1].format('YYYY-MM-DD'))
            Set_time_from(text[0].format('YYYY-MM-DD'))
            Set_time_to(text[1].format('YYYY-MM-DD'))

            // fetch(Apiurl + "/invoices/api?" + new URLSearchParams({
            //     token: localStorage.getItem("token"),
            //     account_id:AccountId,
            //     from_time: text[0].format('YYYY-MM-DD'),
            //     to_time: text[1].format('YYYY-MM-DD'),
            //     time_offset: new Date().getTimezoneOffset().toString(),
            //
            // }))
            //     .then(response => {
            //         return response.json()
            //     })
            //     .then(data => {
            //
            //         settaskscount(data.Allcount)
            //         settasks(data.Data)
            //         setLoading(false)
            //     })

        } else {
            Set_time_from("")
            Set_time_to("")
            // fetch(Apiurl + "/invoices/api?" + new URLSearchParams({
            //     token: localStorage.getItem("token"),
            //     account_id:AccountId,
            //     from_time: "",
            //     to_time: "",
            //     time_offset: new Date().getTimezoneOffset().toString(),
            //
            // }))
            //     .then(response => {
            //         return response.json()
            //     })
            //     .then(data => {
            //
            //         console.log(data.Allcount)
            //         settaskscount(data.Allcount)
            //         settasks(data.Data)
            //         setLoading(false)
            //     })
        }
    };

    const rangePresets = [
        {
            label: 'За 7 дней',
            value: [dayjs().add(-7, 'd'), dayjs()],
        },
        {
            label: 'За 14 дней',
            value: [dayjs().add(-14, 'd'), dayjs()],
        },
        {
            label: 'За 30 дней',
            value: [dayjs().add(-30, 'd'), dayjs()],
        },
        {
            label: 'За 90 дней',
            value: [dayjs().add(-90, 'd'), dayjs()],
        },
    ];

    const onChangeupload = (info) => {
        // Set_time_from("")
        // Set_time_to("")
        // Set_strict_rule(false)
        let newFileList = [...info.fileList];
        setcurrentfile(info.file)
        setFileList(newFileList);
        console.log(newFileList);
    };
    const beforeUpload = (file) => {
        const isTXT= file.type === 'text/plain';
        if (!isTXT) {
            message.error(`${file.name} это не txt`);
        }
        return isTXT || Upload.LIST_IGNORE;
    };

    const segmentedControl = (
        <Segmented
            options={['По строке', 'Файлом SKU', 'Файлом ASIN', {label: 'Все ASIN с продажами', value: 'asinreport'}]}
            value={show_asinreport ? 'asinreport' : selected_segment}
            onChange={(value) => {
                if (value === 'asinreport') {
                    Set_show_asinreport(true)
                    return
                }
                Set_show_asinreport(false)
                if (value !== selected_segment) {
                    setcurrentfile(null)
                    setFileList([])
                }
                Set_selected_segment(value);
            }}
        />
    )

    return (<div>
            <Flex vertical={true} align={"center"} justify={"center"} style={{paddingTop: "25px"}}>
                {show_asinreport &&
                    <Flex vertical={true} align={"center"} gap={"8px"} style={{width: "100%"}}>
                        {segmentedControl}
                        <AsinSalesReport/>
                    </Flex>
                }
                <Card type="flex" style={{maxWidth: "60%", display: show_asinreport ? "none" : undefined}} title={"Выгрузить данные"} justify="center" align="middle">
                    {segmentedControl}
                    {selected_segment==="По строке" &&
                        <Flex style={{marginTop:"20px"}} gap={"15px"} vertical={true}>
                        <RangePicker disabledTime={disabledRangeTime} format="DD.MM.YYYY"
                                     onChange={onChangeFilterfilter_date}
                                     presets={rangePresets}/>

                        <Input
                            placeholder={"SKU"}
                            disabled={asin_text!==""}
                            onChange={(e)=>{
                                Set_sku_text(e.target.value)
                            }}
                        >

                        </Input>
                        <Checkbox value={strict_rule} onChange={(e)=>{
                            Set_strict_rule(e.target.checked)
                        }}>Точный поиск по SKU</Checkbox>

                        <Input
                            disabled={sku_text!==""}
                            onChange={(e)=>{
                                Set_asin_text(e.target.value)
                            }}
                            placeholder={"ASIN"}
                        >

                        </Input>

                        <Button style={{marginTop:"20px"}} type={"primary"} icon={<FileExcelOutlined/>}

                                rel="noreferrer"
                                // htmlType={"a"} target="_blank"
                                // href={Apiurl+"/shopsinfo/excel?"+ new URLSearchParams({
                                //     token: localStorage.getItem("token"),
                                //     skutofind:sku_text,
                                //     asintofind:asin_text,
                                //     strict:strict_rule,
                                //     from_time: time_from,
                                //     to_time: time_to,
                                //
                                //
                                // })}
                                onClick={()=> {
                                    if(time_from==="" || time_to===""){
                                        message.error("Выберите дату!")
                                        return
                                    }

                                    axios.post(Apiurl + "/shopsinfo/excel?" + new URLSearchParams({
                                        token: localStorage.getItem("token"),
                                        skutofind: sku_text,
                                        asintofind: asin_text,
                                        strict: strict_rule,
                                        from_time: time_from,
                                        to_time: time_to,

                                    }),{},{responseType: 'blob'}).then((res: any) => {
                                        if (res.status === 200) {
                                            const url = window.URL.createObjectURL(res.data);
                                            const link = document.createElement('a');
                                            link.href = url;
                                            let filename = res.headers['filename'];
                                            link.setAttribute('download', filename);
                                            document.body.appendChild(link);
                                            link.click();
                                            link.remove();
                                            window.URL.revokeObjectURL(url);
                                        } else {
                                            message.error("Ошибка в отправке запроса!")
                                        }

                                    }).catch((err: Error) => {
                                        console.log(err)
                                    })
                                }
                                }

                        >
                            Скачать отчет
                        </Button>

                        <Button style={{marginTop:"15px"}}

                                onClick={()=>{

                                    axios.get(Apiurl+"/shopsinfo/notexcel?"+ new URLSearchParams({
                                        token: localStorage.getItem("token"),
                                        skutofind:sku_text,
                                        asintofind:asin_text,
                                        strict:strict_rule,
                                        from_time: time_from,
                                        to_time: time_to,

                                    })).then((res: any) => {
                                        if (res.status === 200) {
                                            var inputData=res.data.Data
                                            const columns = inputData[0].map((title, index) => ({
                                                title: title,
                                                dataIndex: title.replace(/s+/g, '_').toLowerCase(), // Заменяем пробелы на подчеркивания и приводим к нижнему регистру
                                                key: title.replace(/s+/g, '_').toLowerCase() // То же самое для ключа
                                            }));

                                            const dataSource = inputData.slice(1).map((row, rowIndex) => {
                                                const obj = {};
                                                row.forEach((value, index) => {
                                                    obj[columns[index].dataIndex] = value; // Заполняем объект значениями из строки
                                                });
                                                return { key: rowIndex + 1, ...obj }; // Добавляем ключ для каждой строки
                                            });


                                            Set_datacloums(columns)
                                            Set_datatable(dataSource)
                                        }else {
                                            message.error("Ошибка в отправке запроса!")
                                        }

                                    }).catch((err: Error) => {
                                        message.error("Пусто!")
                                        console.log(err)
                                    })




                                }}

                        >
                            Посмотреть таблицу онлайн
                        </Button>


                    </Flex>



                    }
                    {
                        selected_segment==="Файлом SKU" &&
                        <Flex style={{marginTop:"20px"}} gap={"15px"} vertical={true}>
                            <RangePicker disabledTime={disabledRangeTime} format="DD.MM.YYYY"
                                         onChange={onChangeFilterfilter_date}
                                         presets={rangePresets}/>


                            <Upload.Dragger maxCount={1} name="files" fileList={fileList} onChange={onChangeupload} beforeUpload={beforeUpload} multiple={false} customRequest={
                                (info)=>{
                                    console.log("9",info)
                                    setFileList([info.file]);
                                }}>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">Нажмите или перетащите сюда ваш файл со SKU</p>
                            </Upload.Dragger>


                            <Checkbox value={strict_rule} onChange={(e)=>{
                                Set_strict_rule(e.target.checked)
                            }}>Точный поиск по SKU</Checkbox>



                            <Button style={{marginTop:"20px"}} type={"primary"} icon={<FileExcelOutlined/>}

                                    rel="noreferrer"
                                // htmlType={"a"} target="_blank"
                                // href={Apiurl+"/shopsinfo/excel?"+ new URLSearchParams({
                                //     token: localStorage.getItem("token"),
                                //     skutofind:sku_text,
                                //     asintofind:asin_text,
                                //     strict:strict_rule,
                                //     from_time: time_from,
                                //     to_time: time_to,
                                //
                                //
                                // })}
                                    onClick={()=> {
                                        if(currentfile===null){
                                            message.error("Загрузите файл!")
                                            return
                                        }
                                        if(time_from==="" || time_to===""){
                                            message.error("Выберите дату!")
                                            return
                                        }
                                        const data= new FormData()

                                        data.append('filesku', currentfile.originFileObj)
                                        // fileList.forEach((item,index)=>{
                                        //     data.append('filesku', item.originFileObj)
                                        //     }
                                        //
                                        // )
                                        const config= {
                                            "headers": {
                                                "content-type": 'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s'
                                            },
                                            "responseType": 'blob'
                                        }

                                        axios.post(Apiurl + "/shopsinfo/excel?" + new URLSearchParams({
                                            token: localStorage.getItem("token"),
                                            strict: strict_rule,
                                            from_time: time_from,
                                            to_time: time_to,

                                        }),data,config).then((res: any) => {
                                            if (res.status === 200) {
                                                const url = window.URL.createObjectURL(res.data);
                                                const link = document.createElement('a');
                                                link.href = url;
                                                let filename = res.headers['filename'];
                                                link.setAttribute('download', filename);
                                                document.body.appendChild(link);
                                                link.click();
                                                link.remove();
                                                window.URL.revokeObjectURL(url);
                                            } else {
                                                message.error("Ошибка в отправке запроса!")
                                            }

                                        }).catch((err: Error) => {
                                            console.log(err)
                                        })
                                    }
                                    }

                            >
                                Скачать отчет
                            </Button>

                            <Button style={{marginTop:"15px"}}

                                    onClick={()=>{
                                        if(currentfile===null){
                                            message.error("Загрузите файл!")
                                            return
                                        }
                                        if(time_from==="" || time_to===""){
                                            message.error("Выберите дату!")
                                            return
                                        }
                                        const data= new FormData()

                                        data.append('filesku', currentfile.originFileObj)
                                        const config= {
                                            "headers": {
                                                "content-type": 'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s'
                                            },

                                        }

                                        axios.post(Apiurl + "/shopsinfo/notexcel?" + new URLSearchParams({
                                            token: localStorage.getItem("token"),
                                            strict: strict_rule,
                                            from_time: time_from,
                                            to_time: time_to,

                                        }),data,config).then((res: any) => {
                                            if (res.status === 200) {
                                                var inputData=res.data.Data
                                                const columns = inputData[0].map((title, index) => ({
                                                    title: title,
                                                    dataIndex: title.replace(/s+/g, '_').toLowerCase(), // Заменяем пробелы на подчеркивания и приводим к нижнему регистру
                                                    key: title.replace(/s+/g, '_').toLowerCase() // То же самое для ключа
                                                }));

                                                const dataSource = inputData.slice(1).map((row, rowIndex) => {
                                                    const obj = {};
                                                    row.forEach((value, index) => {
                                                        obj[columns[index].dataIndex] = value; // Заполняем объект значениями из строки
                                                    });
                                                    return { key: rowIndex + 1, ...obj }; // Добавляем ключ для каждой строки
                                                });


                                                Set_datacloums(columns)
                                                Set_datatable(dataSource)
                                            }else {
                                                message.error("Ошибка в отправке запроса!")
                                            }

                                        }).catch((err: Error) => {
                                            console.log(err)
                                        })




                                    }}

                            >
                                Посмотреть таблицу онлайн
                            </Button>


                        </Flex>
                    }

                    {
                        selected_segment==="Файлом ASIN" &&
                        <Flex style={{marginTop:"20px"}} gap={"15px"} vertical={true}>
                            <RangePicker disabledTime={disabledRangeTime} format="DD.MM.YYYY"
                                         onChange={onChangeFilterfilter_date}
                                         presets={rangePresets}/>


                            <Upload.Dragger maxCount={1} name="files" fileList={fileList} onChange={onChangeupload} beforeUpload={beforeUpload} multiple={false} customRequest={
                                (info)=>{
                                    console.log("9",info)
                                    setFileList([info.file]);
                                }}>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">Нажмите или перетащите сюда ваш файл с ASIN</p>
                            </Upload.Dragger>




                            <Button style={{marginTop:"20px"}} type={"primary"} icon={<FileExcelOutlined/>}

                                    rel="noreferrer"
                                // htmlType={"a"} target="_blank"
                                // href={Apiurl+"/shopsinfo/excel?"+ new URLSearchParams({
                                //     token: localStorage.getItem("token"),
                                //     skutofind:sku_text,
                                //     asintofind:asin_text,
                                //     strict:strict_rule,
                                //     from_time: time_from,
                                //     to_time: time_to,
                                //
                                //
                                // })}
                                    onClick={()=> {
                                        if(currentfile===null){
                                            message.error("Загрузите файл!")
                                            return
                                        }
                                        if(time_from==="" || time_to===""){
                                            message.error("Выберите дату!")
                                            return
                                        }


                                        const data= new FormData()

                                        data.append('fileasin', currentfile.originFileObj)
                                        // fileList.forEach((item,index)=>{
                                        //     data.append('filesku', item.originFileObj)
                                        //     }
                                        //
                                        // )
                                        const config= {
                                            "headers": {
                                                "content-type": 'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s'
                                            },
                                            "responseType": 'blob'
                                        }

                                        axios.post(Apiurl + "/shopsinfo/excel?" + new URLSearchParams({
                                            token: localStorage.getItem("token"),
                                            strict: strict_rule,
                                            from_time: time_from,
                                            to_time: time_to,

                                        }),data,config).then((res: any) => {
                                            if (res.status === 200) {
                                                const url = window.URL.createObjectURL(res.data);
                                                const link = document.createElement('a');
                                                link.href = url;
                                                let filename = res.headers['filename'];
                                                link.setAttribute('download', filename);
                                                document.body.appendChild(link);
                                                link.click();
                                                link.remove();
                                                window.URL.revokeObjectURL(url);
                                            } else {
                                                message.error("Ошибка в отправке запроса!")
                                            }

                                        }).catch((err: Error) => {
                                            console.log(err)
                                        })
                                    }
                                    }

                            >
                                Скачать отчет
                            </Button>

                            <Button style={{marginTop:"15px"}}

                                    onClick={()=>{
                                        if(currentfile===null){
                                            message.error("Загрузите файл!")
                                            return
                                        }
                                        if(time_from==="" || time_to===""){
                                            message.error("Выберите дату!")
                                            return
                                        }
                                        const data= new FormData()

                                        data.append('fileasin', currentfile.originFileObj)
                                        const config= {
                                            "headers": {
                                                "content-type": 'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s'
                                            },

                                        }

                                        axios.post(Apiurl + "/shopsinfo/notexcel?" + new URLSearchParams({
                                            token: localStorage.getItem("token"),
                                            strict: strict_rule,
                                            from_time: time_from,
                                            to_time: time_to,

                                        }),data,config).then((res: any) => {
                                            if (res.status === 200) {
                                                var inputData=res.data.Data
                                                const columns = inputData[0].map((title, index) => ({
                                                    title: title,
                                                    dataIndex: title.replace(/s+/g, '_').toLowerCase(), // Заменяем пробелы на подчеркивания и приводим к нижнему регистру
                                                    key: title.replace(/s+/g, '_').toLowerCase() // То же самое для ключа
                                                }));

                                                const dataSource = inputData.slice(1).map((row, rowIndex) => {
                                                    const obj = {};
                                                    row.forEach((value, index) => {
                                                        obj[columns[index].dataIndex] = value; // Заполняем объект значениями из строки
                                                    });
                                                    return { key: rowIndex + 1, ...obj }; // Добавляем ключ для каждой строки
                                                });


                                                Set_datacloums(columns)
                                                Set_datatable(dataSource)
                                            }else {
                                                message.error("Ошибка в отправке запроса!")
                                            }

                                        }).catch((err: Error) => {
                                            console.log(err)
                                        })




                                    }}

                            >
                                Посмотреть таблицу онлайн
                            </Button>


                        </Flex>
                    }
                </Card>

                <Table  scroll={{ x: 3500, y: 1000 }} style={{marginTop:"45px", maxWidth:"99%", display: show_asinreport ? "none" : undefined}} dataSource={datatable} columns={datacloums}>

                </Table>

            </Flex>

        </div>
    );

}